import Fsm from "./state";
const State = {
  ChooseLevel: "chooseLevel",
  Test: "test",
  Start: "start",
  ChooseFigure: "chooseFigure",
  Survey: "survey",
  Game: "game",
  Editor: "editor",
  GameOver: "gameOver"
};
const Transition = {
  init: {
    from: null,
    to: State.ChooseLevel
  },
  levelChosen: {
    from: State.ChooseLevel,
    to: State.Test
  },
  skipTest: {
    from: State.ChooseLevel,
    to: State.Start
  },
  tested: {
    from: State.Test,
    to: State.Start
  },
  start: {
    from: State.Start,
    to: State.ChooseFigure
  },
  figureChosen: {
    from: State.ChooseFigure,
    to: State.Survey
  },
  cancelChooseFigure: {
    from: State.ChooseFigure,
    to: State.Start
  },
  startWithoutSurvey: {
    from: State.Start,
    to: State.Game
  },
  surveyDone: {
    from: State.Survey,
    to: State.Game
  },
  edit: {
    from: State.Start,
    to: State.Editor
  },
  endEdit: {
    from: State.Editor,
    to: State.Start
  },
  quit: {
    from: State.Start,
    to: State.ChooseLevel
  },
  cancel: {
    from: State.Game,
    to: State.Start
  },
  done: {
    from: State.Game,
    to: State.GameOver
  },
  reset: {
    from: State.GameOver,
    to: State.Start
  }
};
const ScreenState = Fsm({
  State,
  Transition
});
export default ScreenState;
export { State, Transition };